import { api, types } from "api";
import { ComponentProps, Loader } from "components/Loader";
import { useAuthStatus } from "helpers/useAuthStatus";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { routes } from "routes";
import { ParentResult } from "./IndividualResultPage/ParentResultPage";
import { StudentResult } from "./IndividualResultPage/StudentMetricsPage";

export const ParentResultLoadingPage = Loader(
	ParentResult,
	"We are fetching your data",
);

export const GroupLoadingPage = ({
	setLoading,
}: ComponentProps): JSX.Element => {
	const [, setErr] = useState("");
	const [, setGroups] = useState<types.Group[]>([]);
	const history = useHistory();
	useEffect(() => {
		api
			.getGroups()
			.then((res) => {
				if (res.status !== 200) {
					throw new Error();
				}
				setErr("");

				setGroups(res.data || []);
				setLoading(false);
				history.push(routes._.result._.Groups.path, { groups: res.data });
			})
			.catch((err) => {
				setErr(err);
				setLoading(false);
			});
		// eslint-disable-next-line
	}, []);
	return <></>;
};

export const DefaultGroupLoadingPage = Loader(
	GroupLoadingPage,
	"We are fetching your data",
);

export const StudentResultLoadingPage = Loader(
	StudentResult,
	"We are fetching your data",
);

export const ResultPage = (): JSX.Element => {
	const { role } = useAuthStatus();
	if (role === "student") {
		return <StudentResultLoadingPage />;
	} else {
		return <ParentResultLoadingPage />;
	}
};
